import { makeStyles } from '@material-ui/core/styles'
import { grey } from '@material-ui/core/colors'
import Typography from '@material-ui/core/Typography'
import DialogContent from '@material-ui/core/DialogContent'
import Button from '@material-ui/core/Button'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

const useStyles = makeStyles(() => ({
    packedSaleContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    packedSaleContainer: {},
    allConfirmed: {
        display: 'flex',
        alignItems: 'center',
    },
    allConfirmedIcon: {
        fontSize: 60,
        marginRight: 15,
    },
    allConfirmedIconText: {
        color: grey[600],
    },
    saleInformation: {
        marginLeft: 75,
        marginTop: 10,
    },
    channelIcon: {
        height: 30,
        marginBottom: 10,
    },
    saleInfoSaleID: {
        color: grey[600],
        fontSize: '1.3rem !important',
        marginBottom: 10,
    },
    address: {},
    addressText: {
        color: grey[600],
        fontSize: '1.3rem !important',
    },
    nextSaleButton: {
        marginLeft: 75,
        marginTop: 15,
        color: 'white',
    },
    documentsSection: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 75,
        marginTop: 50,
    },
    documentOptionsGroup: {
        display: 'flex',
        flexDirection: 'row',
    },
    documentOptionLabel: {},
    getDocumentsButton: {
        marginTop: 15,
    },
}))

const FulfillmentComplete = ({
    sale,
    fulfillment,
    handleNextFulfillment,
}) => {
    const classes = useStyles()

    if (!sale || !fulfillment) {
        return <DialogContent className={classes.packedSaleContent} />
    }

    return (
        <DialogContent className={classes.packedSaleContent}>
            <div className={classes.packedSaleContainer}>
                <div className={classes.allConfirmed}>
                    <CheckCircleIcon className={classes.allConfirmedIcon} color="primary" />
                    <Typography variant="h5" className={classes.allConfirmedIconText}>
                        {gettext('Packed all items in this order')}
                    </Typography>
                </div>
                <div className={classes.saleInformation}>
                    <img
                        className={classes.channelIcon}
                        src={sale.shop.channel.channel_icon_url}
                        alt="Channel icon"
                    />
                    <Typography variant="h5" className={classes.saleInfoSaleID}>
                        {interpolate(gettext('Order %s'), [sale.sale_id])}
                    </Typography>
                    <div className={classes.address}>
                        <Typography variant="h5" className={classes.addressText}>
                            {sale.address1}
                        </Typography>
                        <Typography variant="h5" className={classes.addressText}>
                            {sale.address2}
                        </Typography>
                        <Typography variant="h5" className={classes.addressText}>
                            {sale.address3}
                        </Typography>
                        <Typography variant="h5" className={classes.addressText}>
                            {sale.address4}
                        </Typography>
                        <Typography variant="h5" className={classes.addressText}>
                            {sale.address5}
                        </Typography>
                        <Typography variant="h5" className={classes.addressText}>
                            {sale.city}
                        </Typography>
                        <Typography variant="h5" className={classes.addressText}>
                            {sale.province}
                        </Typography>
                        <Typography variant="h5" className={classes.addressText}>
                            {sale.post_code}
                        </Typography>
                    </div>
                </div>
                <Button
                    className={classes.nextSaleButton}
                    color="primary"
                    variant="contained"
                    onClick={handleNextFulfillment}
                    size="large"
                    disableFocusRipple
                    disableRipple
                >
                    {gettext('Continue')}
                </Button>
                {/* <div className={classes.documentsSection}>
                    <FormControl component="fieldset">
                        <FormGroup className={classes.documentOptionsGroup}>
                            <FormControlLabel
                                classes={{ label: classes.documentOptionLabel }}
                                control={
                                    <Checkbox
                                        checked={getShippingLabelState}
                                        onChange={handleCheckDocumentOption}
                                        value="getShippingLabel"
                                        disabled={
                                            ![
                                                'waiting_for_shipping_confirmation',
                                                'waiting_for_picking',
                                                'picking',
                                                'packing',
                                                'waiting_for_3pl_pickup',
                                                'waiting_for_3pl_dropoff',
                                            ].includes(fulfillment.status)
                                        }
                                    />
                                }
                                label={gettext('Shipping labels')}
                            />
                            <FormControlLabel
                                classes={{ label: classes.documentOptionLabel }}
                                control={
                                    <Checkbox
                                        checked={getPackListState}
                                        onChange={handleCheckDocumentOption}
                                        value="getPackList"
                                    />
                                }
                                label={gettext('Pack list')}
                            />
                            <FormControlLabel
                                classes={{ label: classes.documentOptionLabel }}
                                control={
                                    <Checkbox
                                        checked={getTaxInvoiceState}
                                        onChange={handleCheckDocumentOption}
                                        value="getTaxInvoice"
                                    />
                                }
                                label={gettext('Tax invoice')}
                            />
                        </FormGroup>
                    </FormControl>
                    <Button
                        className={classes.getDocumentsButton}
                        color="primary"
                        variant="outlined"
                        href={getDocumentsURL()}
                        target="_blank"
                        size="large"
                        disabled={
                            !getShippingLabelState && !getPackListState && !getTaxInvoiceState
                        }
                        disableFocusRipple
                        disableRipple
                    >
                        {gettext('Print documents')}
                    </Button>
                </div> */}
            </div>
        </DialogContent>
    )
}

export default FulfillmentComplete
